/* src/app/intern/mentor-contact-add/mentor-contact-add.component.scss */
.container {
  padding: 20px;
}
mat-form-field {
  width: 100%;
  margin-bottom: 10px;
}
.narrow-field {
  width: 250px;
}
#saveButton {
  width: 130px;
}
/*# sourceMappingURL=mentor-contact-add.component.css.map */
